<template>
    <input type="text" class="form-control">
    <div class="container-fluid">
        <section class="content-header">
            <div class="row mb-2">
                <h3>{{ $t('general.listadoestadospendientes') }}</h3>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-2">
                </div>
                <div class="col-md-10">
                    <tabla-datos :columnas="columnas" :datos="chatsFiltrados" :filtros="false"
                        :total="total" @quieroDatos="obtenerEstadosPendientes" :paginator=false @cambianombre="cambianombre">
                    </tabla-datos>
                </div>
            </div>
        </section>
    </div>
    
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import TablaDatos from '../../../TablaDatos.vue';

export default {
    components: {
        "tabla-datos": TablaDatos,
    },
     computed: {
        // id_estado -> nº de servicios que hay en ese estado (el número entre paréntesis del nombre)
        contadoresServicio() {
            const resp = this.estados_pendientes_servicio;
            let arr = [];

            if (Array.isArray(resp)) {
                arr = resp;
            } else if (resp && typeof resp === 'object') {
                arr = Array.isArray(resp.datos) ? resp.datos : Object.values(resp);
            }

            const mapa = {};
            arr.forEach(e => {
                if (!e || typeof e !== 'object') return;
                const id = e.id_estado ?? e.id;
                if (id === undefined || id === null) return;

                // Captura el número del último paréntesis: "... (0)" -> 0
                const m = String(e.nombre || '').match(/\((\d+)\)\s*$/);
                mapa[String(id)] = m ? parseInt(m[1], 10) : null;
            });

            return mapa;
        },

        chatsFiltrados() {
            let estados = this.estados_pendientes;
            if (!Array.isArray(estados)) {
                estados = estados && typeof estados === 'object' ? Object.values(estados) : [];
            }

            if (this.nombrevalue) {
                estados = estados.filter(estado =>
                    estado.nombre && estado.nombre.toLowerCase().includes(this.nombrevalue.toLowerCase())
                );
            }

            const contadores = this.contadoresServicio;

            return estados.map(estado => {
                const id = String(estado.id_estado ?? estado.id ?? '');
                const num = contadores[id];

                // Solo se puede eliminar si tiene 0 servicios.
                // Si el estado no aparece en el listado de servicios, tampoco tiene servicios -> se permite.
                const puedeEliminar = (num === 0) || (num === undefined);

                return { ...estado, _puedeEliminar: puedeEliminar };
            });
        }
    },
    data() {
        return {
            haynombre: false,
            nombrevalue:'',
            total: '',
            estados_pendientes: [],
            id_estado_pendiente: '',
            estados_pendientes_servicio:'',
            parametros: null, //query params de DataTable,
            permisos_usuario: [],
            columnas: [
                {
                    field: 'nombre',
                    nombrefilt:'nombrefilt',
                    sortable: true,
                },
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'Editar',
                            class: 'editar',
                            tipo: 'default',
                            nombreId: 'id_estado',
                            icono: 'far fa-edit',
                            mostrar: () => this.permisos_usuario.includes('soporte'),
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                
                                this.$router.push({
                                    name: 'Estado Pendiente',
                                    params: {
                                        id
                                    }
                                });
                                
                            }
                        },
                       {
                            nombre: 'Eliminar',
                            class: 'eliminar',
                            tipo: 'danger',
                            nombreId: 'id_estado',
                            icono: 'far fa-trash-alt',
                            mostrar: (fila) => fila && fila._puedeEliminar === true && this.permisos_usuario.includes('soporte'),
                            accion: (id) => {
                                if (confirm('Desea eliminar la especialidad pendiente')) {
                                    this.eliminar(id);
                                }
                            }
                        },
                    ]
                }
            ]
        }
    },
    //  modulos/pwgsapi/index.php/estadospendientes/:id/
    //  modulos/pwgsapi/index.php/estadospendientes/0/
    methods: {
        cambianombre(value){
            this.nombrevalue = value;
        },
        async obtenerEstadosPendientes() {
            const api = new PwgsApi;
            const aux = await api.get('tipos-estado-pendiente');
            this.estados_pendientes = aux.datos.estados_pendientes;
            this.total = this.estados_pendientes.length;
            this.columnas[1].header = this.$t("general.acciones");
        },
        async obtenerEstadosPendientesSerivicio(){
            const api = new PwgsApi();
            const aux = await api.get('listados-servicios/estados-pendientes');
            this.estados_pendientes_servicio = aux.datos;
            console.log("estadospendientesservicio",this.estados_pendientes_servicio);

        },
        async eliminar(id) {
            const api = new PwgsApi;
            await api.delete('tipos-estado-pendiente/' + id);
            this.obtenerEstadosPendientes();
        },
        async comprobarPermisos(){
            const api = new PwgsApi();
            let auxusuario = localStorage.getItem('usuario');
            const resppermisos = await api.get('/usuarios/'+auxusuario+'/permisos');
            for(let permiso of resppermisos.datos){
                this.permisos_usuario.push(permiso.nombre_permiso);
            }
        },
    },
    
    mounted() {
        this.obtenerEstadosPendientes();
        this.obtenerEstadosPendientesSerivicio();
        this.comprobarPermisos();
    },
    watch: {
        '$route'() {
            this.obtenerEstadosPendientes();
            //this.obtenerEstadosPendientes();
            //this.obtenerEstadosPendientesSerivicio();

        }
    }
}
</script>
<style>
.p-dialog {
    width: 90%;
}
</style>